import Svg, { SvgProps, Path } from 'react-native-svg';

const CourseIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M5 2a2 2 0 0 0-2 2 2 2 0 0 0 1 1.73V27a1 1 0 1 0 2 0V5.729A2 2 0 0 0 7 4a2 2 0 0 0-2-2zm3.938 4.002A1.003 1.003 0 0 0 8 7v16a1.003 1.003 0 0 0 1 1c.146 0 .29-.032.426-.096l17-8a1 1 0 0 0 0-1.808l-17-8a1.004 1.004 0 0 0-.489-.094z" />
  </Svg>
);

export default CourseIcon;
